"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../");
var context_1 = require("../../../context");
var ProfileForm = function (_a) {
    var processing = _a.processing, readyOnlyFields = _a.readyOnlyFields;
    var trans = context_1.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(__1.Card, { footer: react_1.default.createElement(__1.Button, { type: __1.ButtonType.submit, processing: processing }, trans('optiiva::labels.update-profile')) },
        react_1.default.createElement(__1.FormControl, { errors: errors.first_name, dusk: "first-name-field", label: trans('optiiva::labels.first-name') },
            react_1.default.createElement(__1.Input, { disabled: processing, dusk: "first-name", name: "first_name" })),
        react_1.default.createElement(__1.FormControl, { errors: errors.last_name, dusk: "last-name-field", label: trans('optiiva::labels.last-name') },
            react_1.default.createElement(__1.Input, { dusk: "last-name", name: "last_name" })),
        react_1.default.createElement(__1.FormControl, { errors: errors.email, dusk: "email-field", label: trans('optiiva::labels.email-address') },
            react_1.default.createElement(__1.Input, { readOnly: readyOnlyFields.email || false, type: __1.InputType.email, dusk: "email", name: "email" })),
        react_1.default.createElement(__1.FormControl, { errors: errors.phone_number, dusk: "phone_number-field", label: trans('optiiva::labels.phone-number') },
            react_1.default.createElement(__1.Input, { name: "phone_number" }))));
};
var ProfileManagementPage = function (_a) {
    var errors = _a.errors, values = _a.values, onSubmit = _a.onSubmit, _b = _a.processing, processing = _b === void 0 ? false : _b, _c = _a.readyOnlyFields, readyOnlyFields = _c === void 0 ? {} : _c;
    return (react_1.default.createElement("div", { className: "w-full max-w-xl" },
        react_1.default.createElement(__1.FormProvider, { initialValues: values, initialErrors: errors, onSubmit: onSubmit },
            react_1.default.createElement(__1.Form, { "data-dusk": "profile-management-form" },
                react_1.default.createElement(ProfileForm, { processing: processing, readyOnlyFields: readyOnlyFields })))));
};
exports.default = ProfileManagementPage;
//# sourceMappingURL=index.js.map